export class Review {
    constructor(public recipeId : number , public tittle: string, public body: string , public rate : number )  {}
  }
  